import React from 'react';
 

export default function Footer() {
  return (
    <footer className="footerS">
        <div>
        <nav className="navbar navbar-dark bg-dark">
        <div className="container">

            <img className="imgS" src="apple-touch-icon.png" alt="SaiyanStack" width="100" height="100" />

            <div className="copy">
            &copy; SaiyanStack 2022
            <br /> <p className="right"> &reg; All Rights Reserved</p>
            </div>  

            <div className="contact">
            <b>Contact</b> <br />Email : piyushpant15@gmail.com<br /> WhatsApp : +91 9145728659 (&#127470;&#127475;)
            </div>

        </div>
        

        </nav>
       
        </div>
    </footer>
  )
}
